import React from 'react';
import { Zap } from 'lucide-react';

function AIUsageBar({ used, limit, tier }) {
  // Pro tier is unlimited (limit = 9999)
  const isUnlimited = tier === 'pro';
  const percentage = isUnlimited ? 0 : (limit > 0 ? Math.min((used / limit) * 100, 100) : 0);
  const remaining = Math.max(0, limit - used);
  
  // Color based on usage percentage
  const getColor = () => {
    if (isUnlimited) return 'bg-purple-500';
    if (percentage >= 90) return 'bg-red-500';
    if (percentage >= 75) return 'bg-yellow-500';
    return 'bg-green-500';
  };

  const getTextColor = () => {
    if (isUnlimited) return 'text-purple-700';
    if (percentage >= 90) return 'text-red-700';
    if (percentage >= 75) return 'text-yellow-700';
    return 'text-green-700';
  };

  return (
    <div className="bg-white rounded-xl border-2 border-gray-200 p-4 shadow-sm">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Zap className="w-5 h-5 text-purple-600" />
          <span className="font-semibold text-gray-900">AI Generations</span>
        </div>
        <span className={`text-sm font-bold ${getTextColor()}`}>
          {isUnlimited ? `${used} used` : `${remaining}/${limit} remaining`}
        </span>
      </div>
      
      {/* Progress Bar */}
      <div className="relative">
        <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
          <div
            className={`${getColor()} h-3 rounded-full transition-all duration-300`}
            style={{ width: isUnlimited ? '100%' : `${percentage}%` }}
          />
        </div>
      </div>
      
      {/* Warning messages */}
      {!isUnlimited && percentage >= 90 && (
        <p className="text-xs text-red-600 mt-2 font-medium">
          ⚠️ Almost at limit! Only {remaining} generations left this month.
        </p>
      )}
      {!isUnlimited && percentage >= 75 && percentage < 90 && (
        <p className="text-xs text-yellow-600 mt-2 font-medium">
          💡 {remaining} generations remaining this month.
        </p>
      )}
      
      {/* Plan info */}
      <p className="text-xs text-gray-500 mt-2">
        Your {tier === 'free' ? 'Free Forever' : tier === 'plus' ? 'Teacher Plus' : 'Teacher Pro'} plan includes {isUnlimited ? 'unlimited' : limit} AI generations per month
      </p>
    </div>
  );
}

export default AIUsageBar;
